import {
  HISTORICAL_QUEUE_REQUEST,
  HISTORICAL_QUEUE_SUCCESS,
  HISTORICAL_QUEUE_ERROR,
  HISTORICAL_STATUS_SUCCESS,
  HISTORICAL_STATUS_ERROR,
  HISTORICAL_STATUS_REQUEST,
  HISTORICAL_TOKEN_REQUEST,
  HISTORICAL_TOKEN_SUCCESS,
  HISTORICAL_TOKEN_ERROR,
  HISTORICAL_TOTAL_POSSIBLE_ORDERS_REQUEST,
  HISTORICAL_TOTAL_POSSIBLE_ORDERS_TOKEN_SUCCESS,
  HISTORICAL_TOTAL_POSSIBLE_ORDERS_TOKEN_ERROR,
} from "./ActionType";

const operationState = {
  shopId: null,
  requestId: null,
  isRequest: false,
  isSuccess: false,
  isError: false,
  error: null,
};

export const initialState = {
  ...operationState,
  status: null,
  queue: {
    ...operationState,
    data: null,
    target: null,
  },
  token: null,
  tokenRequest: { ...operationState },
  possibleOrdersCount: null,
  possibleOrdersRequest: { ...operationState, date: null },
};

const validMeta = (meta) =>
  typeof meta?.shopId === "string" &&
  meta.shopId.length > 0 &&
  typeof meta?.requestId === "string" &&
  meta.requestId.length > 0;

const matches = (operation, meta) =>
  validMeta(meta) &&
  operation.shopId === meta.shopId &&
  operation.requestId === meta.requestId;

const historicalOrdersReducer = (state = initialState, action) => {
  switch (action.type) {
    case HISTORICAL_STATUS_REQUEST:
      if (!validMeta(action.meta)) return state;
      return {
        ...state,
        shopId: action.meta.shopId,
        requestId: action.meta.requestId,
        isRequest: true,
        isSuccess: false,
        isError: false,
        error: null,
        status: null,
      };
    case HISTORICAL_STATUS_SUCCESS:
      if (!matches(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        error: null,
        status: action.payload,
      };
    case HISTORICAL_STATUS_ERROR:
      if (!matches(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        error: action.payload,
        status: null,
      };
    case HISTORICAL_QUEUE_REQUEST:
      if (!validMeta(action.meta)) return state;
      return {
        ...state,
        queue: {
          ...operationState,
          shopId: action.meta.shopId,
          requestId: action.meta.requestId,
          isRequest: true,
          data: null,
          target: action.meta.target || null,
        },
      };
    case HISTORICAL_QUEUE_SUCCESS:
      if (!matches(state.queue, action.meta)) return state;
      return {
        ...state,
        queue: {
          ...state.queue,
          isRequest: false,
          isSuccess: true,
          isError: false,
          error: null,
          data: action.payload,
        },
      };
    case HISTORICAL_QUEUE_ERROR:
      if (!matches(state.queue, action.meta)) return state;
      return {
        ...state,
        queue: {
          ...state.queue,
          isRequest: false,
          isSuccess: false,
          isError: true,
          error: action.payload,
          data: null,
        },
      };
    case HISTORICAL_TOKEN_REQUEST:
      if (!validMeta(action.meta)) return state;
      return {
        ...state,
        token: null,
        tokenRequest: {
          ...operationState,
          shopId: action.meta.shopId,
          requestId: action.meta.requestId,
          isRequest: true,
        },
      };
    case HISTORICAL_TOKEN_SUCCESS:
      if (!matches(state.tokenRequest, action.meta)) return state;
      return {
        ...state,
        token: action.payload,
        tokenRequest: {
          ...state.tokenRequest,
          isRequest: false,
          isSuccess: true,
          isError: false,
          error: null,
        },
      };
    case HISTORICAL_TOKEN_ERROR:
      if (!matches(state.tokenRequest, action.meta)) return state;
      return {
        ...state,
        token: null,
        tokenRequest: {
          ...state.tokenRequest,
          isRequest: false,
          isSuccess: false,
          isError: true,
          error: action.payload,
        },
      };
    case HISTORICAL_TOTAL_POSSIBLE_ORDERS_REQUEST:
      if (!validMeta(action.meta)) return state;
      return {
        ...state,
        possibleOrdersCount: null,
        possibleOrdersRequest: {
          ...operationState,
          shopId: action.meta.shopId,
          requestId: action.meta.requestId,
          isRequest: true,
          date: action.meta.date || null,
        },
      };
    case HISTORICAL_TOTAL_POSSIBLE_ORDERS_TOKEN_SUCCESS:
      if (!matches(state.possibleOrdersRequest, action.meta)) return state;
      return {
        ...state,
        possibleOrdersCount: action.payload,
        possibleOrdersRequest: {
          ...state.possibleOrdersRequest,
          isRequest: false,
          isSuccess: true,
          isError: false,
          error: null,
        },
      };
    case HISTORICAL_TOTAL_POSSIBLE_ORDERS_TOKEN_ERROR:
      if (!matches(state.possibleOrdersRequest, action.meta)) return state;
      return {
        ...state,
        possibleOrdersCount: null,
        possibleOrdersRequest: {
          ...state.possibleOrdersRequest,
          isRequest: false,
          isSuccess: false,
          isError: true,
          error: action.payload,
        },
      };
    default:
      return state;
  }
};

export default historicalOrdersReducer;
